// @flow
import React, { useState } from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import InfoBox from "./../InfoBox";

import Modal from "./../Modal";

const AccordionHeader = styled.div`
  padding: 5px;
  font-weight: bold;
  z-index: 2;
  position: relative;
  font-size: 0.8rem;
  background-color: rgba(100, 100, 100, 0.1);
  color: #000;
`;

const AccordionContent = styled.div`
  padding: 10px;
  overflow: hidden;
  font-size: 0.8rem;
  color: #000;
  max-height: ${props => (props.open ? "2000px" : "0px")};
  opacity: ${props => (props.open ? "1" : "0")};
  transform-origin: 0 0;
  transition: all 650ms ease;
`;

const OpenText = styled.span`
  font-weight: normal;
  font-size: 0.7rem;
  float: right;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const comparisonThead = (
  <thead>
    <tr>
      <th style={{ width: "24%" }} />
      <th colSpan="2" style={{ width: "38%", textAlign: "center" }}>
        <h6>
          <b>Basis-Versicherung</b>
        </h6>
        <div style={{ fontWeight: "normal", fontSize: "0.7rem" }}>
          mit Entschädigungsgrenzen
        </div>
      </th>
      <th colSpan="2" style={{ width: "38%", textAlign: "center" }}>
        <h6>
          <b>Kombi 2000 Komfort</b>
        </h6>
        <div style={{ fontWeight: "normal", fontSize: "0.7rem" }}>
          ohne Entschädigungsgrenzen
        </div>
      </th>
    </tr>
    <tr>
      <th style={{ width: "24%" }} />
      <th style={{ width: "19%" }}>Regelung</th>
      <th style={{ width: "19%" }}>
        <div>Beispiel 24 m² Laube</div>
        <div>max. Entschädigung</div>
      </th>
      <th style={{ width: "19%" }}>Regelung</th>
      <th style={{ width: "19%" }}>
        <div>Beispiel 24 m² Laube</div>
        <div>max. Entschädigung</div>
      </th>
    </tr>
  </thead>
);

export default function VersicherungenInfo({ inBBB }: { inBBB: boolean }) {
  const [open, setOpen] = useState(false);
  const [showTable, setShowTable] = useState(false);

  return (
    <div>
      <AccordionHeader onClick={() => setOpen(!open)}>
        * Informationen zu Versicherungsarten
        <OpenText>{open ? "Ausblenden" : "Einblenden"}</OpenText>
      </AccordionHeader>
      <AccordionContent open={open}>
        <h4 style={{ marginTop: 20, marginBottom: 20 }}>
          A: Kombi-2000-
          {inBBB ? "Plus" : "Komfort"}
          -Versicherung – Unsere Empfehlung
        </h4>
        {inBBB && (
          <>
            <div
              style={{
                padding: 10,
                backgroundColor: "rgba(200, 200, 200, 0.2)",
                borderTop: "3px solid #de2920",
                marginBottom: 15,
                marginLeft: 25
              }}
            >
              <ul>
                <li>Gebäudeversicherung zum gleitenden Neuwert</li>
                <li>Hausratversicherung</li>
                <li>Glasversicherung</li>
              </ul>
            </div>
            <div style={{ marginLeft: 25 }}>
              <div
                style={{
                  padding: 10,
                  backgroundColor: "rgba(200, 200, 200, 0.2)",
                  borderTop: "3px solid #de2920",
                  marginBottom: 15
                }}
              >
                <h5>Gebäudeversicherung zum gleitenden Neuwert</h5>
                <ul>
                  <li>
                    ist eine Versicherung zum gleitenden Neuwert. Wir
                    garantieren im Schadensfall den Wiederaufbauwert der Laube /
                    des Wochenendhauses sowohl bei Stein- als auch bei
                    Holzgebäuden, wenn die bebaute Wohn-/ Nutzfläche richtig
                    angegeben wurde.
                  </li>
                  {inBBB && (
                    <li>
                      gegen Schäden durch Feuer, Sturm/ Hagel und Leitungswasser
                    </li>
                  )}
                </ul>
              </div>
              <div
                style={{
                  padding: 10,
                  backgroundColor: "rgba(200, 200, 200, 0.2)",
                  borderTop: "3px solid #de2920",
                  marginBottom: 15
                }}
              >
                <h5>Hausratversicherung</h5>
                <ul>
                  <li>
                    ist eine Neuwertversicherung mit Unterversicherungsverzicht
                    ohne Sicherungsvorschriften. Bei Gebäudebeschädigungen nach
                    einem Einbruch gibt es keine Kostenbegrenzung.
                  </li>
                  <li>
                    gegen Schäden durch Feuer, Sturm/ Hagel, Leitungswasser,
                    Einbruchdiebstahl, Raub und Vandalismus nach dem Einbruch.
                  </li>
                </ul>
              </div>
            </div>
            <InfoBox style={{ marginLeft: 25 }}>
              <h5>Glasversicherung</h5>
              <p>
                Versichert sind sowohl Einfach- als auch Isolierverglasungen.{" "}
              </p>
              <ul />
            </InfoBox>
          </>
        )}

        {!inBBB && (
          <div style={{ marginLeft: 25 }} className="mt-4">
            <div
              style={{
                padding: 10,
                backgroundColor: "rgba(200, 200, 200, 0.2)",
                borderTop: "3px solid #de2920",
                marginBottom: 15
              }}
            >
              <h6>
                Gebäudeversicherung zum gleitenden Neuwert für Schäden durch
                Feuer, Sturm/Hagel, Leitungswasser.
              </h6>
              <p>
                Wir garantieren im Schadenfall den Wiederaufbauwert der Laube /
                des Wochenendhauses sowohl bei Stein- als auch bei Holzgebäuden,
                wenn die bebaute Wohn- / Nutzfläche richtig angegeben wurde.
              </p>
            </div>
            <div
              style={{
                padding: 10,
                backgroundColor: "rgba(200, 200, 200, 0.2)",
                borderTop: "3px solid #de2920",
                marginBottom: 15
              }}
            >
              <h6>
                Hausratversicherung zum Neuwert für Schäden durch Feuer,
                Sturm/Hagel, Leitungswasser, Einbruchdiebstahl, Vandalismus nach
                Einbruch, Raub
              </h6>
              <p>
                Die Hausratversicherung ist eine Neuwertversicherung mit
                Unterversicherungsverzicht, ohne Sicherungsvorschriften. So gibt
                es z.B. bei Gebäudebeschädigungen nach einem Einbruch keine
                Kostenbegrenzung. Der einfache Diebstahl von Gartenmöbeln ist
                mitversichert.
              </p>
            </div>
            <div
              style={{
                padding: 10,
                backgroundColor: "rgba(200, 200, 200, 0.2)",
                borderTop: "3px solid #de2920",
                marginBottom: 15
              }}
            >
              <h6>Galsversicherung inklusive Isolierverglasung</h6>
              <p>Gebäude- und Mobiliarverglasung</p>
            </div>
          </div>
        )}

        <hr style={{ borderTopWidth: 4 }} className="mt-2 mb-2" />

        {!inBBB && (
          <>
            <h4 style={{ marginTop: 20, marginBottom: 20 }}>
              B: Kombi-2000-Basis-Versicherung
            </h4>
            <div style={{ marginLeft: 25 }}>
              <div
                style={{
                  padding: 10,
                  backgroundColor: "rgba(200, 200, 200, 0.2)",
                  borderTop: "3px solid #de2920",
                  marginBottom: 15
                }}
              >
                <p>
                  Schäden durch <b>Leitungswasser</b> sind{" "}
                  <b>
                    weder in der Gebäude- noch in der Hausratversicherung
                    versichert
                  </b>
                  . Es gelten <b>Entschädigungsgrenzen</b>.
                </p>
              </div>

              <div
                style={{
                  padding: 10,
                  backgroundColor: "rgba(200, 200, 200, 0.2)",
                  borderTop: "3px solid #de2920",
                  marginBottom: 15
                }}
              >
                <ul>
                  <li>
                    <b>Gebäudeversicherung zum Neuwert gegen</b> Schäden durch
                    Feuer, Sturm-/ Hagel, ohne Leitungswasser,
                  </li>
                  <li>
                    <b>
                      Hausratversicherung zum Wiederbeschaffungspreis, ohne
                      Leitungswasser gegen Schäden druch Feuer, Sturm / Hagel,
                      Einbruchdiebstahl, Raub und Vandalismus nach einem
                      Einbruch.
                    </b>
                  </li>
                  <li>
                    <b>Glasversicherung</b> Gebäude- und Mobiliarverglasungen
                    (auch Isolierverglasung)
                  </li>
                </ul>
              </div>
            </div>

            <h6>Entschädigungsgrenzen:</h6>
            <br />
            <h6>Gebäude</h6>
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>
                    <b>Überdachungen / Vordächer</b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 5% der Versicherungssumme
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Sturmschäden</b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 15% der Versicherungssumme
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>
                      nur bei Feuerschäden: bei Zäunen / Einfriedungen und
                      Kulturen
                    </b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 5% der Versicherungssumme{" "}
                  </td>
                </tr>
              </tbody>
            </table>

            <h6>Hausrat</h6>
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>
                    <b>Gebäudebeschädigungen</b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 15% der Versicherungssumme
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Bekleidung</b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 10% der Versicherungssumme
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Lebensmittel</b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 1% der Versicherungssumme
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Fernsehgeräte inkl. Zubehör</b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 10% der Versicherungssumme
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Radio- und Musikanlagen</b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 5% der Versicherungssumme
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>elektrische Werkzeuge insgesamt</b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 10% der Versicherungssumme
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>pro Gerät</b>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    max. 2,5% der Versicherungssumme
                  </td>
                </tr>
              </tbody>
            </table>

            <hr />
          </>
        )}

        <h4 style={{ marginTop: 20, marginBottom: 20 }}>
          {inBBB ? "B:" : "C:"} Gebäudeversicherung zum gleitenden Neuwert
        </h4>
        <div style={{ marginLeft: 25 }}>
          <div
            style={{
              padding: 10,
              backgroundColor: "rgba(200, 200, 200, 0.2)",
              borderTop: "3px solid #de2920",
              marginBottom: 15
            }}
          >
            <ul>
              <li>
                gegen Feuer-, Sturm-, Hagelschäden ggf. Leitungswasserschäden
              </li>
              <li>
                Wir garantieren im Schadensfall den Wiederaufbauwert der Laube /
                des Wochenendhauses sowohl bei Stein- als auch bei Holzgebäuden,
                wenn die bebaute Wohn-/ Nutzfläche richtig angegeben wurde.
              </li>
            </ul>
          </div>
        </div>
      </AccordionContent>
      {!inBBB && (
        <div className="row mb-4">
          <div className="col-12">
            <h5>Unterschiede Komfort/Basis</h5>
          </div>
          <div className="col-12 col-md-6 text-center">
            <a
              className="btn btn-primary"
              target="_blank"
              href="/assets/dokumente/Synopse_abl_Basis_Kombi_Tarif_2000_110419.pdf"
            >
              <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: 15 }} />
              Komfort / Basis Vergleich herunterladen
            </a>
          </div>
          <div className="col-12 col-md-6 text-center">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={() => setShowTable(true)}
            >
              Komfort / Basis Vergleich anzeigen
            </button>
          </div>

          <Modal open={showTable} toggle={() => setShowTable(!showTable)}>
            <div className="table-responsive">
              <p style={{ fontSize: "0.75rem", marginBottom: 10 }}>
                Vergleich (Auszug – nicht vollständig). Beispiel 24 m² Laube –{" "}
                <b>Basis:</b> Gebäude-Versicherungssumme 19.800 €,
                Hausrat-Versicherungssumme 5.600 €; <b>Komfort:</b>{" "}
                Gebäude-Versicherungssumme 25.700 €, Hausrat-Versicherungssumme
                7.400 €. VS = Versicherungssumme.
              </p>

              <h6>Gebäude-Versicherung</h6>
              <table className="table table-striped">
                {comparisonThead}
                <tbody>
                  <tr>
                    <td style={{ width: "24%" }}>
                      <b>Einfriedungen</b>
                    </td>
                    <td style={{ width: "19%" }}>
                      Sturmschäden: 1% der VS
                      <br />
                      Zäune bei Feuer: 5% der VS
                    </td>
                    <td style={{ width: "19%" }}>
                      198 €<br />
                      990 €
                    </td>
                    <td style={{ width: "19%" }}>10% der VS</td>
                    <td style={{ width: "19%" }}>2.570 €</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Aufräumungs- und Abbruchkosten</b>
                    </td>
                    <td>10% der VS</td>
                    <td>1.980 €</td>
                    <td>bis Höhe der VS</td>
                    <td>25.700 €</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Bewegungs- und Schutzkosten</b>
                    </td>
                    <td>10% der VS</td>
                    <td>1.980 €</td>
                    <td>bis Höhe der VS</td>
                    <td>25.700 €</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Mehrkosten infolge behördlicher Auflagen</b>
                    </td>
                    <td>10% der VS</td>
                    <td>1.980 €</td>
                    <td>bis Höhe der VS</td>
                    <td>25.700 €</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Versicherungswert</b>
                    </td>
                    <td>
                      Neuwert: maximal bis zur Höhe der VS, wenn die bebaute
                      Fläche richtig angegeben ist
                    </td>
                    <td>19.800 €</td>
                    <td>
                      Gleitender Neuwert: Wiederaufbauwert, wenn die bebaute
                      Fläche richtig angegeben ist
                    </td>
                    <td>–</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Kulturen bei Feuerschäden</b>
                    </td>
                    <td>nicht versichert</td>
                    <td>–</td>
                    <td>
                      in Gärten: bis 500 € je Schadenfall, in Gewächshäusern
                      ohne Begrenzung
                    </td>
                    <td>–</td>
                  </tr>
                  <tr>
                    <td>
                      <b>
                        Zusatzversicherung: Aufräumungskosten für durch Sturm
                        oder Blitz umgestürzte Bäume
                      </b>
                    </td>
                    <td>nicht versicherbar</td>
                    <td>–</td>
                    <td>versicherbar gegen Mehrbeitrag</td>
                    <td>–</td>
                  </tr>
                </tbody>
              </table>

              <h6>Hausrat-Versicherung</h6>
              <table className="table table-striped">
                {comparisonThead}
                <tbody>
                  <tr>
                    <td style={{ width: "24%" }}>
                      <b>Foto-, Video-, optische Geräte</b>
                    </td>
                    <td style={{ width: "19%" }}>nicht versichert</td>
                    <td style={{ width: "19%" }}>–</td>
                    <td style={{ width: "19%" }}>
                      bei Einbruchdiebstahl: Ferngläser; Bluetooth-Lautsprecher:
                      versichert
                    </td>
                    <td style={{ width: "19%" }}>max. 200 €</td>
                  </tr>
                  <tr>
                    <td>
                      <b>
                        Außen angebrachte Bewegungsmelder, Beleuchtungen,
                        IP-Cams sowie Netzwerkkameras
                      </b>
                    </td>
                    <td>nicht versichert</td>
                    <td>–</td>
                    <td>bis 100 € je Schadenfall</td>
                    <td>max. 100 €</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Überspannungsschäden</b>
                    </td>
                    <td>1% der VS</td>
                    <td>56 €</td>
                    <td>5% der VS</td>
                    <td>370 €</td>
                  </tr>
                  <tr>
                    <td>
                      <b>einfacher Diebstahl von Gartenmöbeln</b>
                    </td>
                    <td>nicht versicherbar</td>
                    <td>–</td>
                    <td>versichert</td>
                    <td>max. 500 €</td>
                  </tr>
                </tbody>
              </table>

              <h6>Glas-Versicherung</h6>
              <table className="table table-striped">
                {comparisonThead}
                <tbody>
                  <tr>
                    <td style={{ width: "24%" }}>
                      <b>Glas</b>
                    </td>
                    <td style={{ width: "19%" }}>15% der Hausrat-VS</td>
                    <td style={{ width: "19%" }}>840 €</td>
                    <td style={{ width: "19%" }}>
                      Gebäude- und Mobiliarverglasung (auch Thermoscheiben)
                    </td>
                    <td style={{ width: "19%" }}>ohne Begrenzung</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Modal>
        </div>
      )}
    </div>
  );
}
